export const typography = {
  h1: {
    fontSize: 28,
    fontWeight: 'bold',
    lineHeight: '34px',
  },
  h2: {
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: '30px',
  },
  h3: {
    fontSize: 20,
    fontWeight: '600',
    lineHeight: '26px',
  },
  body: {
    fontSize: 16,
    lineHeight: '22px',
  },
  small: {
    fontSize: 14,
    lineHeight: '20px',
  },
  caption: {
    fontSize: 12,
    lineHeight: '16px',
  },
};